<template>
  <div
    class="container"
  >
    <dn-main-menu-segment
      v-if="mainMenu.sections?.some((section) => section.name === 'left')"
      class="segment-left"
      type="left"
      :sections="selectSegment('left').sections"
      :selected-block-label="selectedBlockLabel"
      @mouse-over-left="mouseOverLeftSegment = true"
      @mouse-out-left="mouseOverLeftSegment = false"
      @update-selected-block-label="updateSelectedBlockLabel"
      @hide-main-menu="$emit('hide-main-menu')"
    />
    <div
      class="segment-right"
      :class="{'invisible' : mouseOverLeftSegment}"
    >
      <dn-main-menu-segment
        v-if="mainMenu.sections?.some((section) => section.name === 'mid')"
        class="segment-mid"
        type="mid"
        :sections="selectSegment('mid').sections"
        :selected-block-label="selectedBlockLabel"
        @update-selected-block-label="updateSelectedBlockLabel"
        @hide-main-menu="$emit('hide-main-menu')"
      />

      <dn-main-menu-segment
        v-if="mainMenu.sections?.some((section) => section.name === 'bottom')"
        class="segment-bottom"
        type="bottom"
        :blocks="selectSegment('bottom')"
        :selected-block-label="selectedBlockLabel"
        @update-selected-block-label="updateSelectedBlockLabel"
        @hide-main-menu="$emit('hide-main-menu')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { type Sections } from '~/types';

const selectedBlockLabel = ref('');
const mouseOverLeftSegment = ref(false);
const rtConfPub = useRuntimeConfig();
const mainMenu = ref<Sections>(rtConfPub?.public.config.mainMenuConfig);
defineEmits <{(
    e: 'hide-main-menu'): void
}>();
const updateSelectedBlockLabel = (label) => {
  selectedBlockLabel.value = selectedBlockLabel.value === label ? '' : label;
};

const selectSegment = (segmentName) => {
  return mainMenu.value.sections.find((s) => {
    return s.name === segmentName;
  });
};

</script>

<style lang="scss" scoped>
.segment-right {
  flex: 1 0 0%;
  opacity: 1;
  transition: all 0.2s linear;

  label {
    svg {
      @media only screen and (width < 1024px) {
        width: 8px;
        height: 16px;
      }
    }
  }

  &.invisible {
    @media only screen and (width >= 1024px) {
      opacity: 0;
      visibility: hidden;
    }
  }
}
</style>
